export default __webpack_public_path__ + "static/media/Dust Collector Unit.208ee989.jpg";